import { render } from "./HelpfulInfo.vue?vue&type=template&id=0d8ab796&scoped=true"
import script from "./HelpfulInfo.vue?vue&type=script&lang=js"
export * from "./HelpfulInfo.vue?vue&type=script&lang=js"

import "./HelpfulInfo.scss?vue&type=style&index=0&id=0d8ab796&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8ab796"]])

export default __exports__